@if (props['helpComponent']) {
  <ion-item lines="none">
    <ion-label>
      <ng-template #helpTextContainer></ng-template>
    </ion-label>
  </ion-item>
}
@if (props.description) {
  <ion-item lines="none">
    <ion-label>
      <p>
        {{ props.description }}
      </p>
    </ion-label>
  </ion-item>
}
